import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzVday75 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_VDAY_75: Record<
  Exclude<PageIdWoofzVday75, PageIdWoofzVday75.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_VDAY_75]: {
    id: PageId.SUBSCRIPTIONS_VDAY_75,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_VDAY_75]: {
    id: PageId.CHAT_UPSELL_VDAY_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_VDAY_75]: {
    id: PageId.UPSELL_VDAY_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_VDAY_75]: {
    id: PageId.DOWNLOAD_VDAY_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
